export const selectDepositTaxes = (state) => state.depositTaxes;
export const selectWithdrawalTaxes = (state) => state.withdrawalTaxes;
export const selectTaxSetting = (state) => state.setting;
